import { roleHasPermission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";

export function useWorkerDocumentPermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];

  return {
    canRead:
      roleHasPermission(role, "worker_documents:read") ||
      roleHasPermission(role, "worker_documents:read_all"),
    canWrite: roleHasPermission(role, "worker_documents:write"),
    canViewAllTypes: roleHasPermission(role, "worker_documents:read_all"),
  };
}
